import {Swiper} from "swiper/dist/js/swiper.esm";
import {break_sm} from "../../js/constants";
if (window.innerWidth <= break_sm) {
  new Swiper(document.querySelector('.gallerySlider'), {
      speed: 500,
      slidesPerView: 'auto',
    }
  );
}